"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole[UserRole["ADMIN"] = 2] = "ADMIN";
    UserRole[UserRole["SELLER"] = 0] = "SELLER";
    UserRole[UserRole["SELLER_PLUS"] = 4] = "SELLER_PLUS";
    UserRole[UserRole["EXTERNAL_SELLER"] = 5] = "EXTERNAL_SELLER";
    UserRole[UserRole["SERVICE"] = 6] = "SERVICE";
    UserRole[UserRole["OFFICE"] = 7] = "OFFICE";
    UserRole[UserRole["ONLINE_ADMIN"] = 8] = "ONLINE_ADMIN";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
